/**
 * Lookup variables for the page names that should come from the backend route,
 * @type {string}
 */

export const ROOT = 'root';

export const DELIVERY_SEARCH = 'delivery_search';

export const PRODUCTS_ZURICH = 'products_zuerich';
export const PRODUCTS_BERN = 'products_bern';
export const PRODUCT_DETAIL = 'product_detail';

export const CHECKOUT = 'checkout';

export const PROFILE = 'profile';
export const PROFILE_ORDERS = 'profile_orders';
export const PROFILE_ORDERS_DETAIL = 'profile_orders_detail';
export const PROFILE_CUMULUS_PRODUCTS = 'profile_cumulus_products';

// content pages
export const FAQ = 'faq';
export const ABOUT = 'about';
export const LEGAL = 'legal';
export const BECOME_PICKER = 'become_picker';
export const REGION_ZUERICH = 'region_zuerich';
export const REGION_BERN = 'region_bern';
export const PARTNER = 'partner';

// onboarding and prelaunch
export const PRELAUNCH = 'prelaunch';
export const PRELAUNCH_COUNTER = 'prelaunch_counter';




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/page-names.js